
const digest = 'dc61da9f6af187c2a247b6932d84c7b3b879b89b89afda0f7a624a455eb6e93b';
const classes = {"wrapper":"_wrapper_1vjv0_1"};
const css = `._wrapper_1vjv0_1 {
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  font-family: Rubik, sans-serif;
  height: 100%;
  padding: 24px;
  overflow-y: scroll;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_1vjv0_1::-webkit-scrollbar {
  display: block;
}
._wrapper_1vjv0_1::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_1vjv0_1::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_1vjv0_1::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_1vjv0_1::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  